module.exports = __webpack_public_path__ + "img/首页图拷贝.4b0e5c68.png";